<template>
    <v-container grid-list-md>
        <v-flex v-if="activeUser" id="active_user_badge" xs12 class="elevation-3">
            <v-card class="white--text" color="indigo darken-2">
                <div primary-title color="indigo lighten-2" class="indigo pa-2 edit-profile" title="edit profile"
                     @click="goToProfilePage()">
                    <v-flex d-flex xs12>
                        <v-layout row wrap>
                            <v-flex xs4>
                                <img v-if="activeUser.imgFile && activeUser.imgFile.length>0"
                                     class="icon btn--round elevation-3 center-cropped-50 white"
                                     :src="$helper.imgServerUrl() + '/'+activeUser.imgFile">
                                <img v-else="" class="icon btn--round elevation-3 center-cropped-50 white"
                                     :src="$helper.imgServerUrl() + '/'+activeUser.img">
                            </v-flex>
                            <v-flex xs8>
                                <span class="caption">{{activeUser.userName}}</span><br>
                                <v-badge color="green">
                                    <span class="subheading">{{activeUser.firstName + ' ' + activeUser.lastName}}</span>
                                </v-badge>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </div>
            </v-card>
        </v-flex>
    </v-container>
</template>
<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'active-user-badge',
        computed: {
            ...mapGetters(['activeUser'])
        },
        methods: {
            goToProfilePage() {
                ga('send', {
                    hitType: 'event',
                    eventCategory: '/profile',
                    eventAction: 'navigate',
                    eventLabel: "Edit",
                    eventValue: 250
                });
                window.location.href = 'https://admin.tec-stuttgart.de/profile'
            }
        },
    }
</script>
